import React from 'react';
import { Link } from 'react-router-dom';
import './QuizCart.css'

const QuizCart = ({ quiz, quizQuestions }) => {
    const { logo, name, id, total } = quiz
    return (
        <div className='  inline-flex w-96 mt-10 p-10 border-solid border-2 border-indigo-600 mr-10 text-center'>

            <div className='grid grid-cols-1 gap-0'>
                <div className='mt-10 img-fluid '>
                    <img className='quiz-img w-80' src={logo} alt=''></img>
                </div>
                <div className='text-center font-bold text-3xl mr-auto ml-auto'>
                    <h2>{name}</h2>
                    <p className='mt-2'>Total Question : {total}</p>

                </div>
                <div>
                    <Link to={`quiz/${id}`}>

                        <button className=' bg-indigo-600 mt-5 text-white font-bold p-3 border rounded-md hover:bg-violet-600' > Start Practice </button></Link>
                </div>
            </div>

        </div>
    );
};

export default QuizCart;